module.exports = __webpack_public_path__ + "static/media/5.f3100e7e.png";